// Lokalno testiranje: API = backend (VS), PATH = frontend (npm start)
export const API_ROOT = process.env.NODE_ENV === 'production' ? 'https://api.mb51p.com' : 'https://localhost:7212'
export const PATH = process.env.NODE_ENV === 'production' ? 'https://mb51p.com' : 'http://localhost:3000'
export const UNIVERSE = "Еш";
// export const UNIVERSE = "Га";
